var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M4.667 12v-1.334M8 12v-2m3.333 2V8.666M1.667 8c0-2.986 0-4.478.927-5.406.928-.927 2.42-.927 5.406-.927s4.478 0 5.406.927c.927.928.927 2.42.927 5.406s0 4.478-.927 5.406c-.928.927-2.42.927-5.406.927s-4.478 0-5.406-.927c-.927-.928-.927-2.42-.927-5.406"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M3.995 7.657c1.437.048 4.694-.169 6.547-3.11m-1.214-.355 1.25-.201c.153-.02.377.1.432.244l.33 1.092"
  })));
};
export default SvgAnalytics;